import React, { useState } from "react";
import { Button, Form, Input, message, Space, Upload } from "antd";
import axiosClient from "../api/axiosClient";

type Props = {
  form: any;
  name?: any;
  parentField?: any;
  btnText?: string;
  text?: string;
  file_type?: string;
};

const FileUpload: React.FC<Props> = ({
  form,
  name = "file",
  parentField = null,
  btnText = "Upload File",
  text = "No File Uploaded",
  file_type = "image",
}: Props) => {
  const [loading, setLoading] = useState(false);

  const handleCustomRequest = async ({ file, onSuccess, onError }: any) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);
      const response = await axiosClient.post(
        `/files/${file_type}/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const uploadedFileUrl = response.data.url; // Assuming the response contains the file URL
      //   setFileUrl(uploadedFileUrl);
      // setFileName(file.name);
      if (parentField) {
        form.setFieldValue(parentField, uploadedFileUrl);
      } else {
        form.setFieldsValue({
          [name]: uploadedFileUrl,
        });
      }

      onSuccess(response.data); // Notify Upload component of success
      message.success(
        `${btnText === "Upload Logo" ? "Logo" : "File"} uploaded successfully`
      );
    } catch (error) {
      onError(error); // Notify Upload component of error
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space size="large">
      <Form.Item name="file_upload">
        <Space>
          <div style={{ whiteSpace: "nowrap" }}>{text}</div>
          <Upload
            customRequest={handleCustomRequest}
            listType="picture"
            maxCount={1}
            showUploadList={false}
            fileList={[]}
          >
            <Button
              type="primary"
              style={{ background: "#565656" }}
              loading={loading}
            >
              {btnText}
            </Button>
          </Upload>
        </Space>
      </Form.Item>

      <Form.Item name={name}>
        <Input placeholder="Or Enter File URL" />
      </Form.Item>
    </Space>
  );
};

export default FileUpload;
